module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Welcome"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "col-xs-12 card-title csp-card-title"
  }, [_vm._v("Welcome " + _vm._s(_vm.givenName || _vm.authName))])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('p', {
    staticClass: "card-text csp-welcome-text"
  }, [_vm._v("Since this is your first time logging in to Courtyard Stone & Landscape’s client service portal this year, we’d like to ask you to validate your information to make sure our records are accurate.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76d4032a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/panels/Welcome.vue
// module id = 859
// module chunks = 2